import getFormData from '@/util/form-data';
import httpClient from './http-client';

const endpoint = 'api/popup-banners';

const popupBannersService = {
  getPage: (params) => httpClient.get(endpoint, { params }),

  getById: (id) => httpClient.get(`${endpoint}/${id}`),

  search: (query) => httpClient.get(`${endpoint}/find/${query}`),

  create: (popupBanner) => {
    const formData = getFormData(popupBanner);
    return httpClient.post(`${endpoint}`, formData);
  },

  update: (popupBanner) => httpClient.put(`${endpoint}/${popupBanner.id}`, popupBanner),

  reorder: (payload) => httpClient.post('api/popup-banners-reorder', payload),

  delete: (popupBanner) => httpClient.delete(`${endpoint}/${popupBanner.id}`),
};

export default popupBannersService;
